import { util } from 'echarts/core';
import type { VennSeriesOption } from './type';

function getDefaultTitleOption(dataItem) {
  const defaultFontSize = 12;
  const maxLabelCount = 8;
  return {
    label: {
      align: dataItem?.__align,
      color: dataItem?.__color as string,
      width: maxLabelCount * defaultFontSize,
      overflow: 'truncate',
      ellipsis: '...'
    }
  };
}

export function parseTitleStyle(seriesOption: VennSeriesOption) {
  const { data } = seriesOption;

  data.forEach(dataItem => {
    if (dataItem?.__type !== 'title') {
      return;
    }
    const defaultTitleOption = getDefaultTitleOption(dataItem);
    util.merge(dataItem, defaultTitleOption);
  });
}
